import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {HealthQuestionBsiComponent} from "./health-question-bsi.component";
import {LayoutComponent} from "../../layout/layout.component";

const routes: Routes = [
  {
    path: 'health-question-bsi',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: HealthQuestionBsiComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HealthQuestionBsiRoutingModule { }
